<template>
  <v-layout
    v-click-outside="closeMenu"
    class="text-input-container"
  >
    <slot>
    </slot>
    <v-menu
      v-bind="{
      offsetY: true,
      ...menuProps,
    }"
      :close-on-click="true"
      content-class="text-input-menu-content"
      origin="center center"
      v-model="openMenu"
    >
      <template v-slot:activator="{ on, attrs }">
        <VcitaTextField
          v-bind="{...$attrs, ...attrs}"
          autocomplete="off"
          class="text-input-with-select"
          v-on="{...on, ...$listeners}"
          :class="{
            'menu-opened': openMenu
          }"
        >

        </VcitaTextField>
      </template>
      <slot name="menu-slot">
        <v-list ref="selectList">
          <v-list-item
            v-for="(item, index) in filteredItems"
            :key="index"
            :ref="item"
            :class="{active: $attrs.value === item}"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-btn :ref="item" @click="handleClick(item)" :data-qa="`item-${item}`" color="transparent"  class="v-list-button item-text">
                  <v-layout  class="item-text" justify-start>
                    {{ item }}
                  </v-layout>
                </v-btn>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </slot>
    </v-menu>
  </v-layout>
</template>

<script>
  import VcitaTextField from "@/modules/common/components/VcitaTextField/VcitaTextField.vue"
  import ClickOutside from 'vue-click-outside'

  export default {
    name: "TextInputWithSelect",
    components: {
      VcitaTextField,
    },
    directives: {
      ClickOutside
    },
    props: {
      menuProps: {
        type: Object,
        default: () => ({}),
      },
      items: {
        type: Array,
        default: [],
      },
      filterFunc: {
        type: Function,
        default: () => true,
      },
      closeOnClickOutside: {
        type: Boolean,
        default: true,
      },
      popupItemRef: {
        type: Node,
        required: false
      },
    },
    watch: {
      openMenu: {
        async handler(newVal, oldVal) {
          await this.$nextTick()
          if(this.$attrs.value && newVal) {
            await this.$nextTick()
            try {
              const el = this.$refs[this.$attrs.value][0].$el
              setTimeout(() => el.scrollIntoView(), 0)
            } catch (e) {
              console.error(e)
            }

          }
        },
        immediate: true,
      }
    },
    data() {
      return {
        openMenu: false
      }
    },
    methods: {
      async handleClick(item) {
        this.$emit('input', item)
        await this.$nextTick()
        this.$emit('select-input', item)
      },
      closeMenu(event) {
        let isClickInside = event.path.some(el => !!el.className && el.className.includes('v-menu__content'));
        if (!isClickInside)
          this.openMenu = false
      },
    },
    computed: {
      filteredItems() {
        return this.items.filter((item) => this.filterFunc( this.$attrs.value, item ))
      },
      popupItem() {
        return this.popupItemRef ? this.popupItemRef : (this.$refs.selectList && this.$refs.selectList.$el)
      }
    },

  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_i18n-mixins.scss";
  .native-select {
    position: absolute;
    z-index: 0;
    top: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
  .text-input-container {
    position: relative;
  }
  .text-input-with-select {
    position: relative;
    &.menu-opened {
      ::v-deep {
        .v-input__slot {
          border-color: currentColor;
        }
      }
    }
  }
  .item-text {
    font-family: var(--primary-font-family);
    font-weight: normal;
    letter-spacing: normal;
    text-transform: none;
    width: 100%;
  }
  .v-list-button {
    border-radius: 0;
  }

</style>

<style lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_i18n-mixins.scss";
  .text-input-menu-content {
      max-height: 240px;
    .v-list-item__content {
      padding: 0;
    }
    .v-menu__content {
      min-width: 100% !important;
      top: 100% !important;
    }
    .v-list-item {
      min-height: 40px;
      padding: 0;
    }
  }
</style>
